<form [formGroup]="form" class="form" *ngIf="formReady">
  <div class="form-body">
    <div class="form-section">
      <app-form-row [label]="'MODALS.ADD_FAVORITE.NAME' | translateControl : form | async">
        <app-input [type]="'text'" [mainForm]="form" [controlName]="'name'">
        </app-input>
      </app-form-row>
    </div>
  </div>
</form>
